var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScheduleBalancing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520",
    transform: "translate(-350.76 17588.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M9.366,23H2a2,2,0,0,1-2-2L.01,4A2,2,0,0,1,2,2H3V0H5V2H21V0h2V2h1a2,2,0,0,1,2,2v7.015a10.457,10.457,0,0,0-2-1.531V6H2V21H8.443a9.705,9.705,0,0,0,.922,2Z",
    transform: "translate(350.76 -17588.32)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1149",
    "data-name": "Line 1149",
    x2: 18.008,
    y2: 4.502,
    transform: "translate(355.26 -17577.049)",
    fill: "none",
    stroke: "#666",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_236",
    "data-name": "Polygon 236",
    d: "M5.252,0,10.5,6H0Z",
    transform: "translate(358.621 -17574.502)",
    fill: "#0000b5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2321",
    "data-name": "Rectangle 2321",
    width: 3,
    height: 3,
    transform: "translate(356.935 -17581.619) rotate(13)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2322",
    "data-name": "Rectangle 2322",
    width: 3,
    height: 3,
    transform: "translate(370.435 -17578.021) rotate(13)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduleBalancing);
export default __webpack_public_path__ + "static/media/icon_schedule_balancing.c48448548f6a90b523710a6e78b12ccb.svg";
export { ForwardRef as ReactComponent };